import { Currency, currencySymbols } from '../locale/currencies';
import { CurrencyCostMapper } from './unit-prices';

// Fixed display order used in the public API docs price column. Matches the
// historical layout from the old Stoplight LandingPage.md and what crawlers/
// integrators are most likely to expect.
const DISPLAY_CURRENCY_ORDER: readonly Currency[] = ['GBP', 'USD', 'EUR', 'AUD', 'CAD'];

/**
 * Render a CurrencyCostMapper as a "GBP £X / USD $Y / ..." string used in the
 * /api-docs page pricing table. Always emits two decimal places for
 * consistency. Pass the prices already in the unit you want to display
 * (e.g. for carbon removal: pass per-tonne prices and `'per tonne CO₂e'`).
 */
export const formatAllCurrencyPrices = (prices: CurrencyCostMapper, unitSuffix: string): string => {
  const parts = DISPLAY_CURRENCY_ORDER.map(
    currency => `${currency} ${currencySymbols[currency]}${prices[currency].toFixed(2)}`,
  );
  return `${parts.join(' / ')} ${unitSuffix}`;
};
